<div class="dialog">
  @if (dialogTitle()) {
    <h2 style="margin-bottom: 12px;">
      Change Style: <strong>{{ dialogTitle() }}</strong>
    </h2>
  }

  <app-rule-preview [compact]="true" [rules]="[previewRule]" [largeBackground]="true"></app-rule-preview>

  <div class="filter-group">
    <div class="filter-group-body">
      <div class="style-settings">
        @if (allowDisactivate) {
          <div class="filter">
            <span class="filter-body">
              <div class="filter-title" style="width: 90px">
                Active
              </div>
              <span class="sep"></span>
              <div class="filter-title filter-label table-checkbox-group" style="padding-right: 0px;">
                <span class="input-group-btn">
                  <button class="btn toggle-btn" [class.off]="!previewRule.displayOptions.active"
                    (click)="this.previewRule.displayOptions.active = !this.previewRule.displayOptions.active"></button>
                </span>
              </div>
            </span>
          </div>
        }

        @if (previewRule.displayOptions.active && allowHide) {
          <div class="filter">
            <span class="filter-body">
              <div class="filter-title" style="width: 90px">
                Hidden
              </div>
              <span class="sep"></span>
              <div class="filter-title filter-label table-checkbox-group" style="padding-right: 0px;">
                <span class="input-group-btn">
                  <button class="btn toggle-btn" [class.off]="!previewRule.displayOptions.hidden"
                    (click)="this.previewRule.displayOptions.hidden = !this.previewRule.displayOptions.hidden; setCosmeticOptionsFromDisplayOptions();"></button>
                </span>
              </div>
            </span>
          </div>
        }

        @if (previewRule.displayOptions.active) {
          @if (previewRule.displayOptions.displayType === DisplayType.Custom) {
            <div class="cosmetic-settings">
              @if (!previewRule.displayOptions.hidden) {
                <app-cosmetic-settings [cosmeticOptions]="previewRule.displayOptions.cosmeticOptions!" [cosmeticControls]="cosmeticControls" [active]="true"></app-cosmetic-settings>
              } @else {
                <p class="hidden-warning">
                  <strong>Warning!</strong> You are completely hiding these kinds of items.
                </p>
              }
            </div>
          }

          @if (previewRule.displayOptions.displayType === DisplayType.Tier) {
            <span app-select-tier [showDescription]="true" [filter]="filterService.activeFilter().filter" [(tier)]="previewRule.displayOptions.displayTypeTier" (tierChanged)="tierChanged()"></span>

            @if (previewRule.displayOptions.hidden) {
              <p class="hidden-warning">
                <strong>Warning!</strong> You are completely hiding these kinds of items.
              </p>
            }
          }
        }
      </div>
    </div>
  </div>

  <div class="controls dialog-controls">
    <button type="button" class="btn dialog-btn dialog-main-btn" (click)="applyStyle()">
      Apply Changes
    </button>
    <button type="button" class="btn dialog-btn dialog-btn-with-icon" [disabled]="!canCopyStyle" (click)="copyStyle()">
      <span class="icon icon-copy dialog-btn-icon" aria-hidden="true"></span>
      <span>Copy</span>
    </button>
    <button type="button" class="btn dialog-btn dialog-btn-with-icon" [disabled]="!hasClipboard()" (click)="pasteStyle()">
      <span class="icon icon-paste dialog-btn-icon" aria-hidden="true"></span>
      <span>Paste</span>
    </button>
    <button type="button" class="btn dialog-btn dialog-btn-with-icon" [disabled]="!hasLibraryEntries()" (click)="openLibraryPicker()">
      <span class="icon icon-drawer dialog-btn-icon" aria-hidden="true"></span>
      <span>From Library</span>
    </button>
    @if (defaultCosmeticOptions) {
      <button type="button" class="btn dialog-btn" (click)="resetDefaultStyle()">
        Reset Default Style
      </button>
    }
    @if (canClearUserCustomRuleStyle()) {
      <button type="button" class="btn dialog-btn" (click)="clearUserCustomRuleStyle()">
        Clear
      </button>
    }
    <button type="button" class="btn dialog-btn dialog-cancel-btn" (click)="closeDialog()">
      Cancel
    </button>
  </div>
</div>

@if (libraryPickerOpen) {
  <app-style-library-picker-dialog
    [rarity]="rarity"
    [sockets]="sockets"
    [influence]="influence"
    [fractured]="fractured"
    [veiled]="veiled"
    [isCurrency]="isCurrency"
    [isWaystone]="isWaystone"
    [isPoe1Gem]="isPoe1Gem"
    [isQuestItem]="isQuestItem"
    (selected)="onLibraryStyleSelected($event)"
    (close)="closeLibraryPicker()">
  </app-style-library-picker-dialog>
}
